import get from 'lodash/get';

export const getProductComparison = state => get(state, 'application.applicationDetail.productComparison');
